import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">
      Developed bycmlla, that is just to show my work <br /> i hope you enjoy :)
    </div>
  );
};

export default Footer;
